/**
 * Returns the business's logo URL, straight from what the backend has on
 * file (BusinessProfile.logoUrl / RawBusiness.logoUrl) — no canonical-path
 * guessing. `businessId` is accepted for call-site symmetry with other
 * per-business hooks, but the real logoUrl is authoritative now that the
 * backend persists it (see useBusinessLogoUpload).
 */
export function useBusinessProfilePicture(
  _businessId: string | undefined,
  logoUrl?: string | null
): string | null {
  return logoUrl ?? null;
}
